import React, { Component } from 'react';

class Footer extends Component {
    render() {
        return (
            <div>
                <footer id="footer">
                    <div className="footer-top">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-7 col-md-12">
                                    <div className="footer-widget">
                                        <h4>About</h4>
                                        <p>
                                            synthCity is bridging the knowledge gap of synth creation by building a platform where synth makers of
                                            all experiences can pass knowledge between each other.<span role="img" aria-label="Smiling Face with Smiling Eyes">&nbsp;&#x1F60A;</span> <br /><br />
                                        </p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-12">
                                    <div className="footer-widget">
                                        <h4>Useful Links</h4>
                                        <ul>
                                            <li><a href="/">Home</a></li>
                                            <li><a href="https://app.synthcity.io" target="_blank" without rel="noopener noreferrer">synthCity</a></li>
                                            {/* <li><a href="https://twitter.com/zeenotheinvento" target="_blank" without rel="noopener noreferrer">Twitter</a></li> */}
                                            {/* <li><a href="https://www.facebook.com/p/Mazino-Media-100083735944720/" target="_blank" without rel="noopener noreferrer">Facebook</a></li> */}
                                            {/* <li><a href="https://www.youtube.com/user/deztructicus" target="_blank" without rel="noopener noreferrer">YouTube</a></li> */}
                                            {/* <li><a href="https://www.instagram.com/zeenotheinventor/" target="_blank" without rel="noopener noreferrer">Instagram</a></li> */}
                                            <li><a href="http://www.dadamugamazino.com" target="_blank" without rel="noopener noreferrer">My Personal Website</a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-12">
                                    <div className="footer-widget">
                                        <h4>Privacy</h4>
                                        <p style={{ fontSize: 10 }}>
                                            &copy; Copyright: {(new Date().getFullYear())} <a href='https://www.sojisoft.com' target='_blank'>Sojisoft Limited</a>. All rights reserved. Read the <a href="/terms-privacy">Terms of Use and Privacy Policy</a>.
                                        </p>
                                    </div>
                                </div>
                                {/* <div className="col-lg-3 col-md-6">
                                    <div className="footer-widget">
                                        <h4>Recent Tweets</h4>
                                        <div className="tweet" />
                                    </div>
                                </div>
                                <div className="col-lg-3 col-md-6">
                                    <div className="footer-widget widget-instargram">
                                        <h4>Instagram</h4>
                                        <div id="instafeed" />
                                    </div>
                                </div> */}
                            </div> {/* END row*/}
                        </div> {/* END container*/}
                    </div> {/* END footer-top*/}
                    <div className="footer-bottom">
                        <p>BUILT WITH <i className="fa fa-heart" /> BY <a href="https://www.sojisoft.com">Sojisoft</a></p>
                    </div>
                </footer> {/* END footer*/}
                <div className="scroll-top">
                    <i className="fa fa-angle-up" aria-hidden="true" />
                </div>
            </div>
        );
    }
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/synthcity/Footer.js